// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"kOoppl4m31","breadcrumbs-container":"xlt2eaFLqb","breadcrumbsContainer":"xlt2eaFLqb"};